import { FunctionComponent } from 'react';
import { Typography, Input } from '../../tailwindcomponents';
import { School, Accessibility } from '../../components/icons';
import { Request } from '../../types/capabilityList';

interface TrainingAndManualsProps {
    request: Request,
    viewMode: boolean,
    setRequest: Function,
}

const TrainingAndManuals: FunctionComponent<TrainingAndManualsProps> = ({ request, setRequest, viewMode }) => {

    const onUpdateTrainingAndManuals = (field: keyof Request, value: string) => {
        setRequest((prevState: Request) => ({
            ...prevState,
            [field]: value,
        }));
    };

    return (
        <div className="flex flex-col items-center mt-7 w-full">
            <Typography color='primary' variant='h2' text={"Training & Manuals"} align='center' />
            <div className="flex flex-wrap justify-center gap-6 mt-4 w-full max-w-5xl px-4">
                <div className="w-full sm:w-5/12">
                    <Input icon={<School />} disabled={viewMode} multiline={true} help_text={""} label_text={"Special training"} value={request.special_training} onTextChange={(text: string) => { onUpdateTrainingAndManuals("special_training", text) }} type="text" width={100} />
                </div>
                <div className="w-full sm:w-5/12">
                    <Input icon={<Accessibility />} disabled={viewMode} multiline={true} help_text={""} label_text={"Manuals needed by shop"} value={request.manuals_needed_by_shop} onTextChange={(text: string) => { onUpdateTrainingAndManuals("manuals_needed_by_shop", text) }} type="text" width={100} />
                </div>
            </div>
        </div>
    )
}
export default TrainingAndManuals;